import { BlurView as BlurViewRN, } from 'utils/packages/rnBlurView';
import React from 'react';
import { Platform } from 'react-native';
export const BlurView = ({ children, style, ...props }) => (<BlurViewRN style={style} blurType="light" blurAmount={Platform.select({ android: 25, default: 5 })} {...props}>
    {children}
  </BlurViewRN>);
